import Microgame from '../engine/Microgame.js';

export default class PizzaGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Pizza !`, en: `Pizza!`, es: `¡Pizza!` },
            controls: { fr: `Glisse ton doigt au milieu de la pizza pour la couper`, en: `Swipe across the middle of the pizza to cut it`, es: `Desliza por el medio de la pizza para cortarla` },
            objective: { fr: `Coupe des parts de pizza parfaites`, en: `Cut perfect pizza slices`, es: `Corta porciones de pizza perfectas` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M12 2A10 10 0 0 1 22 12c-5.5 0-10-4.5-10-10Z"/><path d="M16 8h.01"/><path d="M12 2a10 10 0 1 0 10 10"/></svg>`,
            actions: [
                { type: 'wait', duration: 280 },
                { type: 'swipe', fromX: 22, fromY: 70, toX: 50, toY: 44, duration: 620 },
                { type: 'wait', duration: 220 },
                { type: 'swipe', fromX: 78, fromY: 70, toX: 54, toY: 52, duration: 620 },
                { type: 'wait', duration: 500 },
            ],
            loopDuration: 3200
        };
    }
    constructor(engine) {
        super(engine);
        this.toppings = [];
        this.placedChorizoCount = 0;
        this.activeTopping = null;
        
        // Difficulty scaling: 4s at x1, 1.6s at x4
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeed = 1 + (speedMult - 1) * 0.5; // 1.0 -> 1.0, 4.0 -> 2.5
        this.duration = 4000 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "CHORIZO ONLY!";

        // Pizza Slice (Triangle) - Primary
        const pizza = document.createElement('div');
        pizza.style.position = 'absolute';
        pizza.style.width = '0';
        pizza.style.height = '0';
        pizza.style.borderLeft = '150px solid transparent';
        pizza.style.borderRight = '150px solid transparent';
        pizza.style.borderTop = `350px solid ${this.primaryColor}`;
        pizza.style.top = '15%';
        pizza.style.left = '50%';
        pizza.style.transform = 'translateX(-50%)';
        pizza.style.filter = `drop-shadow(0 0 10px ${this.primaryColor})`;
        this.container.appendChild(pizza);

        // Crust (Top bar) - Secondary
        const crust = document.createElement('div');
        crust.style.position = 'absolute';
        crust.style.width = '320px';
        crust.style.height = '40px';
        crust.style.background = this.secondaryColor;
        crust.style.top = '-390px';
        crust.style.left = '-160px';
        crust.style.borderRadius = '20px 20px 0 0';
        crust.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        pizza.appendChild(crust);

        // Toppings: 2 Chorizos, 1 Pineapple
        const flavors = this.isPlayback
            ? ['chorizo', 'chorizo', 'pineapple']
            : ['chorizo', 'chorizo', 'pineapple'];
        if (!this.isPlayback) {
            for (let i = flavors.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [flavors[i], flavors[j]] = [flavors[j], flavors[i]];
            }
        }

        this.startPositions = [];

        for (let i = 0; i < 3; i++) {
            const flavor = flavors[i];
            const topping = document.createElement('div');
            topping.style.position = 'absolute';
            topping.style.width = '60px';
            topping.style.height = '60px';
            topping.style.display = 'flex';
            topping.style.alignItems = 'center';
            topping.style.justifyContent = 'center';
            
            if (flavor === 'pineapple') {
                topping.innerHTML = `
                    <svg width="60" height="60" viewBox="0 0 60 60">
                        <!-- Pineapple Body -->
                        <path d="M30 15 C20 15 15 25 15 35 C15 45 20 55 30 55 C40 55 45 45 45 35 C45 25 40 15 30 15 Z" fill="${this.primaryColor}" />
                        <!-- Texture Crosses -->
                        <path d="M22 25 L38 45 M38 25 L22 45" stroke="rgba(0,0,0,0.2)" stroke-width="2" />
                        <!-- Spiky Leaves -->
                        <path d="M30 5 L22 18 L38 18 Z" fill="${this.secondaryColor}" />
                        <path d="M22 8 L18 20 L28 18 Z" fill="${this.secondaryColor}" transform="rotate(-20, 30, 20)" />
                        <path d="M38 8 L42 20 L32 18 Z" fill="${this.secondaryColor}" transform="rotate(20, 30, 20)" />
                    </svg>
                `;
                topping.style.filter = `drop-shadow(0 0 10px ${this.primaryColor})`;
            } else {
                topping.style.background = this.secondaryColor;
                topping.style.borderRadius = '50%';
                topping.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
                // Chorizo texture
                const dot = document.createElement('div');
                dot.style.width = '30px';
                dot.style.height = '30px';
                dot.style.border = '2px dashed rgba(0,0,0,0.3)';
                dot.style.borderRadius = '50%';
                topping.appendChild(dot);
            }

            // Randomized start positions
            const deterministic = [
                { x: 22, y: 70, rot: -10 },
                { x: 78, y: 70, rot: 12 },
                { x: 50, y: 76, rot: 0 }
            ];
            const startX = this.isPlayback ? deterministic[i].x : (15 + Math.random() * 70); // 15% to 85%
            const startY = this.isPlayback ? deterministic[i].y : (60 + Math.random() * 20); // 60% to 80%
            const startRot = this.isPlayback ? deterministic[i].rot : ((Math.random() - 0.5) * 40); // -20 to 20 deg

            topping.style.top = `${startY}%`;
            topping.style.left = `${startX}%`;
            topping.style.transform = `rotate(${startRot}deg)`;
            topping.style.cursor = 'grab';
            topping.style.touchAction = 'none';

            topping.dataset.placed = 'false';
            topping.dataset.id = i;
            topping.dataset.flavor = flavor;

            this.startPositions.push({ x: startX, y: startY, rot: startRot });

            this.container.appendChild(topping);
            this.toppings.push(topping);

            topping.addEventListener('pointerdown', (e) => this.onDown(e, topping));
        }

        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e, topping) {
        if (!this.active || this.won || this.lost || topping.dataset.placed === 'true') return;
        this.activeTopping = topping;
        topping.style.cursor = 'grabbing';
        topping.style.zIndex = '100';

        const rect = topping.getBoundingClientRect();
        this.offsetX = e.clientX - rect.left - rect.width / 2;
        this.offsetY = e.clientY - rect.top - rect.height / 2;
        
        // Remove individual rotation while dragging
        topping.style.transform = 'rotate(0deg) scale(1.1)';
        topping.style.transition = 'transform 0.1s ease-out';
    }

    onMove(e) {
        if (!this.activeTopping) return;

        const rect = this.container.getBoundingClientRect();
        const x = e.clientX - rect.left - this.offsetX;
        const y = e.clientY - rect.top - this.offsetY;

        this.activeTopping.style.left = `${x}px`;
        this.activeTopping.style.top = `${y}px`;
    }

    onUp(e) {
        if (!this.activeTopping) return;

        // Check if on Pizza
        const rect = this.container.getBoundingClientRect();
        const centerX = rect.width * 0.5;
        const centerY = rect.height * 0.4;

        const tRect = this.activeTopping.getBoundingClientRect();
        const tx = tRect.left + tRect.width / 2 - rect.left;
        const ty = tRect.top + tRect.height / 2 - rect.top;

        const dist = Math.hypot(tx - centerX, ty - centerY);
        const id = parseInt(this.activeTopping.dataset.id);
        const startPos = this.startPositions[id];

        if (dist < 180) {
            const flavor = this.activeTopping.dataset.flavor;
            
            if (flavor === 'pineapple') {
                this.activeTopping.style.transform = 'scale(2)';
                this.lose();
                return;
            }

            this.activeTopping.dataset.placed = 'true';
            this.activeTopping.style.cursor = 'default';
            this.placedChorizoCount++;

            this.activeTopping.style.transform = 'scale(1.2)';
            this.activeTopping.style.transition = 'transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
            setTimeout(() => { if(this.activeTopping) this.activeTopping.style.transform = 'scale(1)'; }, 100);

            if (this.placedChorizoCount >= 2) {
                this.win();
            }
        } else {
            // Reset to original randomized start position
            this.activeTopping.style.left = `${startPos.x}%`;
            this.activeTopping.style.top = `${startPos.y}%`;
            this.activeTopping.style.transform = `rotate(${startPos.rot}deg)`;
            this.activeTopping.style.cursor = 'grab';
        }

        this.activeTopping.style.zIndex = '';
        this.activeTopping = null;
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
